<script setup lang="ts">
import type { KDropdownItem } from "@kaleidoscope-solutions/ks-design-system"
import { AccessDeniedIcon } from "@kaleidoscope-solutions/ks-icons/vue/light/index.js"

interface Props {
  item: KDropdownItem
}

defineProps<Props>()
</script>

<template>
  <div
    v-if="item.disabled"
    v-tooltip.right.icon="item.tooltip"
    class="flex items-center gap-1"
  >
    <AccessDeniedIcon class="size-4 shrink-0 text-black" />
    <span>{{ item.label }}</span>
  </div>
  <div
    v-else
    class="flex items-center gap-1"
  >
    <span>{{ item.label }}</span>
  </div>
</template>
